import React, { createRef } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import 'vendor/photoswipe/dist/photoswipe.css';
import 'vendor/photoswipe/dist/default-skin/default-skin.css';
import PhotoSwipe from 'vendor/photoswipe/dist/photoswipe.js';
import PhotoSwipeUI_Default from 'vendor/photoswipe/dist/photoswipe-ui-default.js';

import Fab from '@material-ui/core/Fab';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import GetAppIcon from '@material-ui/icons/GetApp';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import PrintIcon from '@material-ui/icons/Print';
import PrintDisabledIcon from '@material-ui/icons/PrintDisabled';
import PaletteIcon from '@material-ui/icons/Palette';
import CropIcon from '@material-ui/icons/Crop';
import { Popup, Modal } from 'semantic-ui-react';

import {
  getCartMoments
} from 'shared/selectors/cartSelectors'

import {
  setPhotoSwipeOpen,
  setPhotoSwipeMoment,
  showAuthorizeKnockout,
  showCropMoment,
  showPrintSizeEdits
} from 'app/actions/photoSwipeActions';

import {
  selectMoments,
  unselectMoments,
  selectPrints,
  unselectPrints
} from 'shared/actions/cartActions';

import {
  selectMoments as selectKioskMoments,
  unselectMoment as unselectKioskMoment
} from 'app/actions/kioskActions';

class PhotoSwipeWrapper extends React.Component {
  constructor(props) {
    super(props);

    this.pswpElement = createRef();
    this.running = false;
    this.state = {
      showAuthorize: false
    };
  }

  componentDidUpdate() {
    let index = this.props.index || 0;
    if (!index && this.props.momentId) {
      for (let i = 0, l = this.props.items.length; i < l; i++) {
        if (this.props.items[i].id === this.props.momentId) {
          index = i;
          break;
        }
      }
    }

    const options = {
      index: index,
      closeOnScroll: false,
      history: false,
      tapToToggleControls: false,
      fullscreenEl: false,
      closeEl: true,
      zoomEl: true,
      tapToClose: false,
      mouseUsed: true,
      preload: [2, 2],
      arrowKeys: false,
    };

    //if (!this.photoSwipe) {
    if (this.props.open) {
      if (!this.running) {
        this.photoSwipe = new PhotoSwipe(
          this.pswpElement.current,
          PhotoSwipeUI_Default,
          this.props.items,
          options
        );

        this.photoSwipe.init();

        this.photoSwipe.listen('afterChange', () => {
          this.props.setPhotoSwipeMoment(this.photoSwipe.currItem);
        });

        this.photoSwipe.listen('destroy', () => {
          this.props.setPhotoSwipeOpen(false);
        });

        this.running = true
      }
    } else {
      if (this.photoSwipe) {
        this.photoSwipe.close();
        this.photoSwipe = null;
        this.running = false;
      }
    }
    //}
  }

  selected() {
    let momentId;
    if (this.photoSwipe) {
      momentId = this.photoSwipe.currItem.id;
    } else {
      momentId = this.props.momentId;
    }

    if (this.props.selectKioskItem) {
      return this.props.selectedKioskMomentIds.indexOf(momentId) !== -1;
    } else {
      return this.props.selectedMomentIds.indexOf(momentId) !== -1;
    }
  }

  toggleSelected() {
    if (this.props.purchased) {
      return;
    }

    const momentId = this.photoSwipe.currItem.id;

    if (this.selected()) {
      this.unselectMoment(momentId);
    } else {
      this.selectMoment(momentId);
    }
  }

  selectMoment(momentId) {
    const { settings, user } = this.props;

    if (this.props.purchased) {
      return;
    }

    if (this.props.selectKioskItem) {
      this.props.selectKioskMoments(settings.token, user.story_id, [momentId]);
    } else {
      this.props.selectMoments(user.story_id, [momentId]);
    }
  }

  unselectMoment(momentId) {
    const { settings, user } = this.props;

    if (this.props.purchased) {
      return;
    }

    if (this.props.selectKioskItem) {
      this.props.unselectKioskMoment(settings.token, user.story_id, momentId);
    } else {
      this.props.unselectMoments(user.story_id, [momentId]);
    }
  }

  togglePrint() {
    if (this.props.purchased) {
      return;
    }

    const momentId = this.photoSwipe.currItem.id;
    const selected = this.props.selectedPrintMomentIds.indexOf(momentId) !== -1;

    if (selected) {
      this.props.unselectPrints([momentId]);
    } else {
      if (!this.selected()) {
        this.selectMoments([momentId]);
      }

      this.props.selectPrints([momentId]);
    }
  }

  handleShowAuthorize() {
    this.photoSwipe.close();
    this.props.showAuthorizeKnockout(true, this.photoSwipe.currItem.id);
  }

  handleShowCropMoment() {
    this.photoSwipe.close();
    this.props.showPrintSizeEdits(true, this.photoSwipe.currItem);
  }

  render() {
    if (!this.props.open) {
      return null;
    }

    let knockoutIcon = null;
    let cropIcon = null;
    let checkbox = null;
    if ((this.props.selectCartItem || this.props.selectKioskItem)) {
      const momentId = this.props.momentId;
      const selectedMoment = this.props.cartMoments.find(x => x.id === momentId)
      const checkboxStyle = {
        position: 'relative',
        float: 'left',
        color: '#fff',
        fontSize: '2.5rem',
        cursor: 'pointer'
      }

      if (this.selected()) {
        checkboxStyle.color = 'rgb(0 174 230)';
      }

      checkbox = (
        <div style={{ position: 'absolute', top: 0, left: 0, zIndex: 99999 }}>
          <div style={{ display: this.selected() ? 'inline' : 'none', position: 'absolute', top: 0, left: 0, borderRadius: '5px', width: '1.5rem', height: '1.5rem', margin: '0.5rem', background: '#fff' }} />
          <CheckBoxIcon style={checkboxStyle} onClick={() => this.toggleSelected()} />
        </div>
      );

      if (selectedMoment && selectedMoment.digital_edit) {
        knockoutIcon = (
          <Popup
            content='Reknockout Moment'
            trigger={
              <button className="pswp__button pswp__button--knockout"
                style={{ background: "none" }}>
                <PaletteIcon style={{ color: "#fff", height: "18px" }} onClick={this.handleShowAuthorize.bind(this)} />
              </button>
            }>
          </Popup>
        );
      }

      if (this.props.selectCartItem && this.props.settings.enable_edits) {
        cropIcon = (
          <Popup
            content='Crop Image'
            trigger={
              <button className="pswp__button pswp__button--crop"
                style={{ background: "none" }}>
                <CropIcon style={{ color: "#fff", height: "18px" }} onClick={this.handleShowCropMoment.bind(this)} />
              </button>
            }>
          </Popup>
        );
      }
    }


    return (
      <div
        className="pswp"
        tabIndex="-1"
        role="dialog"
        aria-hidden="true"
        style={this.props.style}
        ref={this.pswpElement}>
        {checkbox}
        <style>{'.pswp__top-bar {opacity: 1 !important; background: #222 !important}'}</style>
        <div className="pswp__bg" style={{ background: '#222' }} />
        <div className="pswp__scroll-wrap">
          <div className="pswp__container">
            <div className="pswp__item" />
            <div className="pswp__item" />
            <div className="pswp__item" />
          </div>
          <div className="pswp__ui pswp__ui--hidden">
            <div className="pswp__top-bar">
              <div className="pswp__counter" style={{ display: 'none' }} />
              <button className="pswp__button pswp__button--close" title="Close (Esc)" />
              <button className="pswp__button pswp__button--fs" title="Toggle fullscreen" />
              <button className="pswp__button pswp__button--zoom" title="Zoom in/out" />

              {knockoutIcon}
              {cropIcon}

              <div className="pswp__preloader">
                <div className="pswp__preloader__icn">
                  <div className="pswp__preloader__cut">
                    <div className="pswp__preloader__donut" />
                  </div>
                </div>
              </div>
            </div>
            <div className="pswp__share-modal pswp__share-modal--hidden pswp__single-tap">
              <div className="pswp__share-tooltip" />
            </div>
            <button className="pswp__button pswp__button--arrow--left" title="Previous (arrow left)" />
            <button className="pswp__button pswp__button--arrow--right" title="Next (arrow right)" />
            <div className="pswp__caption">
              <div className="pswp__caption__center" />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  settings: state.kioskReducer.settings,
  user: state.kioskReducer.user,
  open: state.photoSwipeReducer.open,
  index: state.photoSwipeReducer.index,
  momentId: state.photoSwipeReducer.momentId,
  purchased: state.photoSwipeReducer.purchased,
  items: state.photoSwipeReducer.items,
  selectedMomentIds: state.cartReducer.selectedMomentIds,
  selectedPrintMomentIds: state.cartReducer.selectedPrintMomentIds,
  selectedKioskMomentIds: state.kioskReducer.selectedMomentIds,
  cartMoments: getCartMoments(state)
});

export default connect(mapStateToProps, { showAuthorizeKnockout, setPhotoSwipeOpen, setPhotoSwipeMoment, selectMoments, unselectMoments, selectPrints, unselectPrints, selectKioskMoments, unselectKioskMoment, showCropMoment, showPrintSizeEdits })(PhotoSwipeWrapper);
